
const Bugsnag = {
  notify(err) {
    err = (err instanceof Error) ? err : new Error(err);
    Bugsnag.call('notifyException', [err]);
  },

  breadCrumb(name, metaData) {
    Bugsnag.call('leaveBreadcrumb', [name, metaData]);
  },

  call(name, params) {
  // This is a generic way to call any funciton on bugsnag with any amount of params.
  // EG: bugsag.call('notifyException', [err]); === window.Bugsnag.notifyException(err);
  // This could be replaced with Proxies when it's stable. https://babeljs.io/learn-es2015/#ecmascript-2015-features-proxies
    window.Bugsnag && window.Bugsnag[name](...params);
  },
};

export default Bugsnag;
